'use strict';

import React from 'react'

import Link from '@Pure/Link'

export default class MenuItem extends React.Component
{
	render ()
	{
		const props = this.props, component = this;

		let class_name = props.className || '', sub_menu, sub_items;

		class_name += props.base_class;

		let active_class = '';

		if (props.history.location.pathname === props.path && props.base_class)
		{
			active_class = ' ' + props.base_class + '--active';
		}

		if (props.history.location.pathname.indexOf(props.path + '/') === 0)
		{
			active_class = ' ' + props.base_class + '--actived';
		}

		if (['/dashboard', '/accueil'].includes(props.path))
		{
			if (props.history.location.pathname !== props.path &&
			props.history.location.pathname !== props.path + '/')
			{
				active_class = '';
			}
		}

		if (!props.path) active_class = '';

		class_name += active_class;

		if ((props.sub_items || []).length > 0)
		{
			sub_items = props.sub_items.map(function (item, index)
			{
				let active_class = '';

				if (props.history.location.pathname === item.href)
				{
					active_class = ' is-active';
				}

				if (props.history.location.pathname.indexOf(item.href + '/') === 0)
				{
					active_class = ' is-activated';
				}

				let output =
				(
					<li className={ 'c-sub-menu__item' + active_class } key={ index }>
						<Link className={ 'c-sub-menu__link' + active_class }
							href={ item.href }>
							{ item.title }
						</Link>
					</li>
				);

				return output;
			});

			let sub_class = 'c-sub-menu';

			if (props.open)
			{
				sub_class += ' c-sub-menu--open';
			}

			sub_menu =
			(
				<div className={ sub_class }>
					<ul className="c-sub-menu__menu">
						{ sub_items }
					</ul>
				</div>
			);

			class_name += ' ' + props.base_class + '--dropdown';
		}

		let output =
		(
			<li className={ class_name }>

				{ props.children }

				{ sub_menu }

			</li>
		);

		return output;
	}
}